module.exports = __webpack_public_path__ + "static/about-header-img-66503a3cac33d361434a315398bfc963.png";